'use client';
import { ComponentType } from 'react';
import { PlaceholderConfig } from '@spa/lib/react/context/PlaceholderContext';
import { Props } from './newsletter.component';
import dynamic from 'next/dynamic';

const DynamicNewsletterComponent: ComponentType<Props> = dynamic(
  () => import('./newsletter.component')
);

export default DynamicNewsletterComponent;

export function calculateNewsletterPlaceholderConfig(): PlaceholderConfig {
  const heightSinceWidth = [
    { sinceWidth: 0, height: 210 },
    { sinceWidth: 768, height: 250 },
    { sinceWidth: 1024, height: 250 }
  ];
  return { heightSinceWidth };
}
